function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { sortAvailablePaymentMethods } from '../../../../../venia-ui/lib/components/CheckoutPage/utils';
import { Magento2 } from '../../../RestApi';
import { closeDrawer } from '../app';
import { createCart, removeCart } from '../cart';
import actions from './actions';
import BrowserPersistence from '../../../util/simplePersistence';
var storage = new BrowserPersistence();
var {
  request
} = Magento2;
export var setEmailToCart = payload => /*#__PURE__*/function () {
  var _thunk = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.setEmailToCart(payload));
  });
  function thunk(_x) {
    return _thunk.apply(this, arguments);
  }
  return thunk;
}();
export var setSubscribeToNewsletter = payload => /*#__PURE__*/function () {
  var _thunk2 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.setSubscribeToNewsletter(payload));
  });
  function thunk(_x2) {
    return _thunk2.apply(this, arguments);
  }
  return thunk;
}();
export var setDeliveryMethods = payload => /*#__PURE__*/function () {
  var _thunk3 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.setDeliveryMethods(payload));
    storage.setItem('deliveryMethods', payload);
    dispatch(actions.setSelectedShippingMethod(null));
  });
  function thunk(_x3) {
    return _thunk3.apply(this, arguments);
  }
  return thunk;
}();
export var setCartDetails = payload => /*#__PURE__*/function () {
  var _thunk4 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.setCartDetails(payload));
  });
  function thunk(_x4) {
    return _thunk4.apply(this, arguments);
  }
  return thunk;
}();
export var setAvailablePaymentMethods = payload => /*#__PURE__*/function () {
  var _thunk5 = _asyncToGenerator(function* (dispatch) {
    var _payload = sortAvailablePaymentMethods(payload);
    dispatch(actions.setAvailablePaymentMethods(_payload));
  });
  function thunk(_x5) {
    return _thunk5.apply(this, arguments);
  }
  return thunk;
}();
export var setAvailableShippingMethods = payload => /*#__PURE__*/function () {
  var _thunk6 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.setAvailableShippingMethods(payload));
  });
  function thunk(_x6) {
    return _thunk6.apply(this, arguments);
  }
  return thunk;
}();
export var setShippingAddress = payload => /*#__PURE__*/function () {
  var _thunk7 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.setShippingAddress(payload));
  });
  function thunk(_x7) {
    return _thunk7.apply(this, arguments);
  }
  return thunk;
}();
export var setSelectedShippingMethod = payload => /*#__PURE__*/function () {
  var _thunk8 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.setSelectedShippingMethod(payload));
  });
  function thunk(_x8) {
    return _thunk8.apply(this, arguments);
  }
  return thunk;
}();
export var setPaymentInformations = payload => /*#__PURE__*/function () {
  var _thunk9 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.setPaymentInformations(payload));
  });
  function thunk(_x9) {
    return _thunk9.apply(this, arguments);
  }
  return thunk;
}();
export var setNextButtonLoader = payload => /*#__PURE__*/function () {
  var _thunk10 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.setNextButtonLoader(payload));
  });
  function thunk(_x10) {
    return _thunk10.apply(this, arguments);
  }
  return thunk;
}();
export var setShippingFormState = payload => /*#__PURE__*/function () {
  var _thunk11 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.setShippingFormState(payload));
  });
  function thunk(_x11) {
    return _thunk11.apply(this, arguments);
  }
  return thunk;
}();
export var setShippingMethodsLoader = payload => /*#__PURE__*/function () {
  var _thunk12 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.setShippingMethodsLoader(payload));
  });
  function thunk(_x12) {
    return _thunk12.apply(this, arguments);
  }
  return thunk;
}();
export var setAppliedCoupon = payload => /*#__PURE__*/function () {
  var _thunk13 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.setAppliedCoupon(payload));
  });
  function thunk(_x13) {
    return _thunk13.apply(this, arguments);
  }
  return thunk;
}();
export var setAppliedGiftCard = payload => /*#__PURE__*/function () {
  var _thunk14 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.setAppliedGiftCard(payload));
  });
  function thunk(_x14) {
    return _thunk14.apply(this, arguments);
  }
  return thunk;
}();
export var setGrandTotal = payload => /*#__PURE__*/function () {
  var _thunk15 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.setGrandTotal(payload));
  });
  function thunk(_x15) {
    return _thunk15.apply(this, arguments);
  }
  return thunk;
}();
export var setInStorePickUpInfo = payload => /*#__PURE__*/function () {
  var _thunk16 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.setInStorePickUpInfo(payload));
  });
  function thunk(_x16) {
    return _thunk16.apply(this, arguments);
  }
  return thunk;
}();
export var reset = () => /*#__PURE__*/function () {
  var _thunk17 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.reset());
  });
  function thunk(_x17) {
    return _thunk17.apply(this, arguments);
  }
  return thunk;
}();
export var beginCheckout = () => /*#__PURE__*/function () {
  var _thunk18 = _asyncToGenerator(function* (dispatch) {
    // Before we begin, reset the state of checkout to clear out stale data.
    dispatch(actions.reset());
    var storedAvailableShippingMethods = yield retrieveAvailableShippingMethods();
    var storedBillingAddress = yield retrieveBillingAddress();
    var storedPaymentMethod = yield retrievePaymentMethod();
    var storedShippingAddress = yield retrieveShippingAddress();
    var storedShippingMethod = yield retrieveShippingMethod();
    dispatch(actions.begin({
      availableShippingMethods: storedAvailableShippingMethods || [],
      billingAddress: storedBillingAddress,
      paymentCode: storedPaymentMethod && storedPaymentMethod.code,
      paymentData: storedPaymentMethod && storedPaymentMethod.data,
      shippingAddress: storedShippingAddress || {},
      shippingMethod: storedShippingMethod && storedShippingMethod.carrier_code,
      shippingTitle: storedShippingMethod && storedShippingMethod.carrier_title
    }));
  });
  function thunk(_x18) {
    return _thunk18.apply(this, arguments);
  }
  return thunk;
}();
export var cancelCheckout = () => /*#__PURE__*/function () {
  var _thunk19 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.reset());
  });
  function thunk(_x19) {
    return _thunk19.apply(this, arguments);
  }
  return thunk;
}();
export var resetCheckout = () => /*#__PURE__*/function () {
  var _thunk20 = _asyncToGenerator(function* (dispatch) {
    yield dispatch(closeDrawer());
    dispatch(actions.reset());
  });
  function thunk(_x20) {
    return _thunk20.apply(this, arguments);
  }
  return thunk;
}();
export var resetReceipt = () => /*#__PURE__*/function () {
  var _thunk21 = _asyncToGenerator(function* (dispatch) {
    yield dispatch(actions.receipt.reset());
  });
  function thunk(_x21) {
    return _thunk21.apply(this, arguments);
  }
  return thunk;
}();
export var submitPaymentMethodAndBillingAddress = payload => /*#__PURE__*/function () {
  var _thunk22 = _asyncToGenerator(function* (dispatch) {
    var {
      countries,
      formValues
    } = payload;
    var {
      billingAddress,
      paymentMethod
    } = formValues;
    return Promise.all([dispatch(submitBillingAddress({
      billingAddress,
      countries
    })), dispatch(submitPaymentMethod(paymentMethod))]);
  });
  function thunk(_x22) {
    return _thunk22.apply(this, arguments);
  }
  return thunk;
}();
export var submitBillingAddress = payload => /*#__PURE__*/function () {
  var _thunk23 = _asyncToGenerator(function* (dispatch, getState) {
    dispatch(actions.billingAddress.submit());
    var {
      cart
    } = getState();
    var {
      cartId
    } = cart;
    if (!cartId) {
      throw new Error('Missing required information: cartId');
    }
    try {
      var {
        billingAddress,
        countries
      } = payload;
      var desiredBillingAddress = billingAddress;
      if (!billingAddress.sameAsShippingAddress) {
        desiredBillingAddress = formatAddress(billingAddress, countries);
      }
      yield saveBillingAddress(desiredBillingAddress);
      dispatch(actions.billingAddress.accept(desiredBillingAddress));
    } catch (error) {
      dispatch(actions.billingAddress.reject(error));
      throw error;
    }
  });
  function thunk(_x23, _x24) {
    return _thunk23.apply(this, arguments);
  }
  return thunk;
}();
export var submitPaymentMethod = payload => /*#__PURE__*/function () {
  var _thunk24 = _asyncToGenerator(function* (dispatch, getState) {
    dispatch(actions.paymentMethod.submit());
    var {
      cart
    } = getState();
    var {
      cartId
    } = cart;
    if (!cartId) {
      throw new Error('Missing required information: cartId');
    }
    try {
      yield savePaymentMethod(payload);
      dispatch(actions.paymentMethod.accept(payload));
    } catch (error) {
      dispatch(actions.paymentMethod.reject(error));
      throw error;
    }
  });
  function thunk(_x25, _x26) {
    return _thunk24.apply(this, arguments);
  }
  return thunk;
}();
export var submitShippingAddress = function () {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return /*#__PURE__*/function () {
    var _thunk25 = _asyncToGenerator(function* (dispatch, getState) {
      dispatch(actions.shippingAddress.submit());
      var {
        formValues,
        countries,
        setGuestEmail,
        setShippingAddressOnCart
      } = payload;
      var {
        cart,
        user
      } = getState();
      var {
        cartId
      } = cart;
      if (!cartId) {
        throw new Error('Missing required information: cartId');
      }
      try {
        var address = formatAddress(formValues, countries);
        if (!user.isSignedIn) {
          if (!formValues.email) {
            throw new Error('Missing required information: email');
          }
          yield setGuestEmail({
            variables: {
              cartId,
              email: formValues.email
            },
            fetchPolicy: "no-cache"
          });
        }
        var {
          firstname,
          lastname,
          street,
          city,
          region_code,
          postcode,
          telephone,
          country_id
        } = address;
        var {
          data
        } = yield setShippingAddressOnCart({
          variables: {
            cartId,
            firstname,
            lastname,
            street,
            city,
            region_code,
            postcode,
            telephone,
            country_id
          },
          fetchPolicy: "no-cache"
        });
        // We can get the shipping methods immediately after setting the
        // address. Grab it from the response and put it in the store.
        var shippingMethods = data.setShippingAddressesOnCart.cart.shipping_addresses[0].available_shipping_methods;

        // On success, save to local storage.
        yield saveAvailableShippingMethods(shippingMethods);
        yield saveShippingAddress(address);
        dispatch(actions.getShippingMethods.receive(shippingMethods));
        dispatch(actions.shippingAddress.accept(address));
      } catch (error) {
        dispatch(actions.shippingAddress.reject(error));
        throw error;
      }
    });
    function thunk(_x27, _x28) {
      return _thunk25.apply(this, arguments);
    }
    return thunk;
  }();
};
export var submitShippingMethod = payload => /*#__PURE__*/function () {
  var _thunk26 = _asyncToGenerator(function* (dispatch, getState) {
    dispatch(actions.shippingMethod.submit());
    var {
      cart
    } = getState();
    var {
      cartId
    } = cart;
    if (!cartId) {
      throw new Error('Missing required information: cartId');
    }
    try {
      var desiredShippingMethod = payload.formValues.shippingMethod;
      yield saveShippingMethod(desiredShippingMethod);
      dispatch(actions.shippingMethod.accept(desiredShippingMethod));
    } catch (error) {
      dispatch(actions.shippingMethod.reject(error));
      throw error;
    }
  });
  function thunk(_x29, _x30) {
    return _thunk26.apply(this, arguments);
  }
  return thunk;
}();
export var submitOrder = _ref => {
  var {
    fetchCartId
  } = _ref;
  return /*#__PURE__*/function () {
    var _thunk27 = _asyncToGenerator(function* (dispatch, getState) {
      dispatch(actions.order.submit());
      var {
        cart,
        user
      } = getState();
      var {
        cartId
      } = cart;
      if (!cartId) {
        throw new Error('Missing required information: cartId');
      }
      var billing_address = yield retrieveBillingAddress();
      var paymentMethod = yield retrievePaymentMethod();
      var shipping_address = yield retrieveShippingAddress();
      var shipping_method = yield retrieveShippingMethod();
      if (billing_address.sameAsShippingAddress) {
        billing_address = shipping_address;
      }
      try {
        // POST to shipping-information to submit the shipping address and shipping method.
        var guestShippingEndpoint = "/rest/V1/guest-carts/".concat(cartId, "/shipping-information");
        var authedShippingEndpoint = '/rest/V1/carts/mine/shipping-information';
        var shippingEndpoint = user.isSignedIn ? authedShippingEndpoint : guestShippingEndpoint;
        yield request(shippingEndpoint, {
          method: 'POST',
          body: JSON.stringify({
            addressInformation: {
              billing_address,
              shipping_address,
              shipping_carrier_code: shipping_method.carrier_code,
              shipping_method_code: shipping_method.method_code
            }
          })
        });

        // POST to payment-information to submit the payment details and billing address,
        // Note: this endpoint also actually submits the order.
        var guestPaymentEndpoint = "/rest/V1/guest-carts/".concat(cartId, "/payment-information");
        var authedPaymentEndpoint = '/rest/V1/carts/mine/payment-information';
        var paymentEndpoint = user.isSignedIn ? authedPaymentEndpoint : guestPaymentEndpoint;
        var response = yield request(paymentEndpoint, {
          method: 'POST',
          body: JSON.stringify({
            billingAddress: billing_address,
            cartId: cartId,
            email: shipping_address.email,
            paymentMethod: {
              additional_data: {
                payment_method_nonce: paymentMethod.data.nonce
              },
              method: paymentMethod.code
            }
          })
        });
        dispatch(actions.receipt.setOrder({
          id: response,
          shipping_address
        }));

        // Clear out everything we've saved about this cart from local
        // storage. Then remove and create a new cart.
        yield clearCheckoutDataFromStorage();
        yield dispatch(removeCart());
        try {
          dispatch(createCart({
            fetchCartId
          }));
        } catch (error) {
          // If creating a cart fails, all is not lost. Return so that the
          // user can continue to at least browse the site.
          return;
        }
        dispatch(actions.order.accept());
      } catch (error) {
        dispatch(actions.order.reject(error));
        throw error;
      }
    });
    function thunk(_x31, _x32) {
      return _thunk27.apply(this, arguments);
    }
    return thunk;
  }();
};
export var createAccount = _ref2 => {
  var {
    history
  } = _ref2;
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(function* (dispatch, getState) {
      var {
        checkout
      } = getState();
      var {
        email,
        firstname: firstName,
        lastname: lastName
      } = checkout.receipt.order.shipping_address;
      var accountInfo = {
        email,
        firstName,
        lastName
      };

      // Once we grab what we need from checkout state we can reset.
      yield dispatch(resetCheckout());
      history.push("/create-account?".concat(new URLSearchParams(accountInfo)));
    });
    return function (_x33, _x34) {
      return _ref3.apply(this, arguments);
    };
  }();
};

/* helpers */

/**
 * Formats an address in the shape the REST API expects.
 * TODO: Can we remove this code once address submissions switch to GraphQL?
 *
 * This function may throw.
 *
 * @param {object} address - The input address.
 * @param {object[]} countries - The list of countries data.
 */
export var formatAddress = function () {
  var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var countries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var {
    region_code
  } = address;
  var usa = countries.find(_ref4 => {
    var {
      id
    } = _ref4;
    return id === 'US';
  });
  var {
    available_regions: regions
  } = usa;
  var region = regions.find(_ref5 => {
    var {
      code
    } = _ref5;
    return code === region_code;
  });
  return _objectSpread({
    country_id: 'US',
    region_id: region.id,
    region_code: region.code,
    region: region.name
  }, address);
};
function clearAvailableShippingMethods() {
  return _clearAvailableShippingMethods.apply(this, arguments);
}
function _clearAvailableShippingMethods() {
  _clearAvailableShippingMethods = _asyncToGenerator(function* () {
    return storage.removeItem('availableShippingMethods');
  });
  return _clearAvailableShippingMethods.apply(this, arguments);
}
function retrieveAvailableShippingMethods() {
  return _retrieveAvailableShippingMethods.apply(this, arguments);
}
function _retrieveAvailableShippingMethods() {
  _retrieveAvailableShippingMethods = _asyncToGenerator(function* () {
    return storage.getItem('availableShippingMethods');
  });
  return _retrieveAvailableShippingMethods.apply(this, arguments);
}
function saveAvailableShippingMethods(_x35) {
  return _saveAvailableShippingMethods.apply(this, arguments);
}
function _saveAvailableShippingMethods() {
  _saveAvailableShippingMethods = _asyncToGenerator(function* (methods) {
    return storage.setItem('availableShippingMethods', methods);
  });
  return _saveAvailableShippingMethods.apply(this, arguments);
}
function clearBillingAddress() {
  return _clearBillingAddress.apply(this, arguments);
}
function _clearBillingAddress() {
  _clearBillingAddress = _asyncToGenerator(function* () {
    return storage.removeItem('billingAddress');
  });
  return _clearBillingAddress.apply(this, arguments);
}
function retrieveBillingAddress() {
  return _retrieveBillingAddress.apply(this, arguments);
}
function _retrieveBillingAddress() {
  _retrieveBillingAddress = _asyncToGenerator(function* () {
    return storage.getItem('billingAddress');
  });
  return _retrieveBillingAddress.apply(this, arguments);
}
function saveBillingAddress(_x36) {
  return _saveBillingAddress.apply(this, arguments);
}
function _saveBillingAddress() {
  _saveBillingAddress = _asyncToGenerator(function* (address) {
    return storage.setItem('billingAddress', address);
  });
  return _saveBillingAddress.apply(this, arguments);
}
function clearPaymentMethod() {
  return _clearPaymentMethod.apply(this, arguments);
}
function _clearPaymentMethod() {
  _clearPaymentMethod = _asyncToGenerator(function* () {
    return storage.removeItem('paymentMethod');
  });
  return _clearPaymentMethod.apply(this, arguments);
}
function retrievePaymentMethod() {
  return _retrievePaymentMethod.apply(this, arguments);
}
function _retrievePaymentMethod() {
  _retrievePaymentMethod = _asyncToGenerator(function* () {
    return storage.getItem('paymentMethod');
  });
  return _retrievePaymentMethod.apply(this, arguments);
}
function savePaymentMethod(_x37) {
  return _savePaymentMethod.apply(this, arguments);
}
function _savePaymentMethod() {
  _savePaymentMethod = _asyncToGenerator(function* (method) {
    return storage.setItem('paymentMethod', method);
  });
  return _savePaymentMethod.apply(this, arguments);
}
function clearShippingAddress() {
  return _clearShippingAddress.apply(this, arguments);
}
function _clearShippingAddress() {
  _clearShippingAddress = _asyncToGenerator(function* () {
    return storage.removeItem('shippingAddress');
  });
  return _clearShippingAddress.apply(this, arguments);
}
function retrieveShippingAddress() {
  return _retrieveShippingAddress.apply(this, arguments);
}
function _retrieveShippingAddress() {
  _retrieveShippingAddress = _asyncToGenerator(function* () {
    return storage.getItem('shippingAddress');
  });
  return _retrieveShippingAddress.apply(this, arguments);
}
function saveShippingAddress(_x38) {
  return _saveShippingAddress.apply(this, arguments);
}
function _saveShippingAddress() {
  _saveShippingAddress = _asyncToGenerator(function* (address) {
    return storage.setItem('shippingAddress', address);
  });
  return _saveShippingAddress.apply(this, arguments);
}
function clearShippingMethod() {
  return _clearShippingMethod.apply(this, arguments);
}
function _clearShippingMethod() {
  _clearShippingMethod = _asyncToGenerator(function* () {
    return storage.removeItem('shippingMethod');
  });
  return _clearShippingMethod.apply(this, arguments);
}
function retrieveShippingMethod() {
  return _retrieveShippingMethod.apply(this, arguments);
}
function _retrieveShippingMethod() {
  _retrieveShippingMethod = _asyncToGenerator(function* () {
    return storage.getItem('shippingMethod');
  });
  return _retrieveShippingMethod.apply(this, arguments);
}
function saveShippingMethod(_x39) {
  return _saveShippingMethod.apply(this, arguments);
}
function _saveShippingMethod() {
  _saveShippingMethod = _asyncToGenerator(function* (method) {
    return storage.setItem('shippingMethod', method);
  });
  return _saveShippingMethod.apply(this, arguments);
}
export var clearCheckoutDataFromStorage = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator(function* () {
    yield clearBillingAddress();
    yield clearPaymentMethod();
    yield clearShippingAddress();
    yield clearShippingMethod();
    yield clearAvailableShippingMethods();
  });
  return function clearCheckoutDataFromStorage() {
    return _ref6.apply(this, arguments);
  };
}();